import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Button, Card } from "reactstrap"
import { useOfficeTranslation } from "i18n/OfficeTranslation"

interface Props {
  box: string;
  unread: number;
}

const EmailSideBar: React.FC<Props> = ({ box, unread }) => {
  const { t } = useOfficeTranslation();

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  return (
    <React.Fragment>
      {box === "compose" && <button type="button" className="btn btn-light composer-mailbox-toggle" aria-expanded={expanded} aria-controls="composer-mailboxes" onClick={() => setExpanded(value => !value)}>
        <i className="bx bxs-inbox me-2" aria-hidden="true" />{t("email.composer.mailboxes")}
        <i className={`mdi mdi-chevron-${expanded ? "up" : "down"} ms-auto`} aria-hidden="true" />
      </button>}
      <Card id={box === "compose" ? "composer-mailboxes" : undefined} className={`email-leftbar ${box === "compose" ? `composer-mailboxes ${expanded ? "is-expanded" : ""}` : ""}`}>
        <Button
          type="button"
          color="danger"
          className="btn btn-danger btn-block waves-effect waves-light fw-semibold"
          onClick={() => {
            //setmodal(!modal)
            navigate("/conversations/compose")
          }}
          block

        >
          {t("common.compose")}
        </Button>
        <div className="mail-list mt-4">
          <Link to={"/conversations/inbox"} className={box === "inbox" ? "active" : ""}>
            <i className="bx bxs-inbox font-size-16 align-middle me-2"></i> {t("email.emailSideBar.inbox")}{" "}
            <span className="ml-1 float-end">{unread > 0 && (unread)}</span>
          </Link>
          <Link to={"/conversations/starred"} className={box === "starred" ? "active" : ""}>
            <i className="bx bx-star font-size-16 align-middle me-2"></i>{t("email.emailSideBar.starred")}
          </Link>
          <Link to={"/conversations/sent"} className={box === "sent" ? "active" : ""}>
            <i className="bx bx-mail-send font-size-16 align-middle me-2"></i>{t("email.emailSideBar.sent")}
          </Link>
        </div>

        <h6 className="mt-4">{t("email.emailSideBar.labels")}</h6>

        <div className="mail-list mt-1">
          <span className="mdi mdi-circle text-success me-2"></span>
          {t("common.invoices")}
          <br />
          <span className="mdi mdi-circle text-danger me-2"></span>
          {t("common.tickets")}
        </div>
      </Card>
    </React.Fragment>
  )
}

export default EmailSideBar
